import { render } from "./FormPhotoMotorcycle.vue?vue&type=template&id=518eff6b"
import script from "./FormPhotoMotorcycle.vue?vue&type=script&lang=js"
export * from "./FormPhotoMotorcycle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__